import { Component } from '@angular/core';
import { Placement } from '@popperjs/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {
  placements: Placement[] = [
    'auto', 'top', 'bottom', 'right', 'left'
  ];
  selectedPlacement: Placement = 'auto';
  languages: string[] = [
    'English', 'Spanish', 'Hindi'
  ];
  selectedLanguage: string = 'English';
  hasCloseButton: boolean = false;
  hasCaret: boolean = false;

  message: string = 'Content goes here';
  englishMessage: string = 'Content goes here';
  spanishMessage: string = 'El contenido va aquí';
  hindiMessage: string = 'विवरण यहाँ जाता है';

  onLanguageChange() {
    if (this.selectedLanguage === 'English') {
      this.message = this.englishMessage;
    }
    if (this.selectedLanguage === 'Spanish') {
      this.message = this.spanishMessage;
    }
    if (this.selectedLanguage === 'Hindi') {
      this.message = this.hindiMessage;
    }
  }
}